module.exports = __webpack_public_path__ + "img/wallpaper_fc.b3e43f3d.png";